import { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const navItems = [
  { label: '首页', to: '/' },
  { label: '剧集分类', to: '/category' },
  { label: '关于我们', to: '/about' },
];

export default function SiteHeader() {
  const location = useLocation();
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const isActive = (to: string) => (to === '/' ? location.pathname === '/' : location.pathname.startsWith(to));

  const submitSearch = (event: React.FormEvent) => {
    event.preventDefault();
    const value = keyword.trim();
    navigate(value ? `/search?q=${encodeURIComponent(value)}` : '/search');
    setMenuOpen(false);
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/95 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-[1400px] items-center gap-4 px-4 md:h-20 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-circle-fill text-xl" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-base font-semibold tracking-tight text-foreground-950 md:text-lg">
              妈妈的朋友在线观看
            </span>
            <span className="font-label mt-0.5 text-[10px] uppercase tracking-[0.18em] text-foreground-400">
              Drama Streaming
            </span>
          </span>
        </Link>

        <nav className="ml-4 hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                isActive(item.to)
                  ? 'bg-primary-50 text-primary-700'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-950'
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="ml-auto hidden lg:block">
          <div className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2 transition-colors focus-within:border-primary-400">
            <i className="ri-search-line text-base text-foreground-400" />
            <input
              type="text"
              value={keyword}
              onChange={(event) => setKeyword(event.target.value)}
              placeholder="搜索剧名、演员"
              className="w-40 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none xl:w-56"
            />
          </div>
        </form>

        <Link
          to="/search"
          aria-label="搜索"
          className="ml-auto flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-600 hover:bg-background-100 lg:ml-0 lg:hidden"
        >
          <i className="ri-search-line text-lg" />
        </Link>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((value) => !value)}
          className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 hover:bg-background-100 md:hidden"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 md:hidden">
          <div className="mx-auto w-full max-w-[1400px] px-4 py-4">
            <form onSubmit={submitSearch} className="mb-4">
              <div className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-3 py-2.5">
                <i className="ri-search-line text-base text-foreground-400" />
                <input
                  type="text"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  placeholder="搜索剧名、演员"
                  className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none"
                />
              </div>
            </form>
            <nav className="flex flex-col">
              {navItems.map((item) => (
                <Link
                  key={item.to}
                  to={item.to}
                  className={`flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium ${
                    isActive(item.to) ? 'bg-primary-50 text-primary-700' : 'text-foreground-700'
                  }`}
                >
                  {item.label}
                  <i className="ri-arrow-right-s-line text-foreground-400" />
                </Link>
              ))}
            </nav>
          </div>
        </div>
      )}
    </header>
  );
}